import { render, staticRenderFns } from "./jumpPage.vue?vue&type=template&id=6f935f48&scoped=true&"
import script from "./jumpPage.vue?vue&type=script&lang=js&"
export * from "./jumpPage.vue?vue&type=script&lang=js&"
import style0 from "./jumpPage.vue?vue&type=style&index=0&id=6f935f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f935f48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f935f48')) {
      api.createRecord('6f935f48', component.options)
    } else {
      api.reload('6f935f48', component.options)
    }
    module.hot.accept("./jumpPage.vue?vue&type=template&id=6f935f48&scoped=true&", function () {
      api.rerender('6f935f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/nine/jumpPage.vue"
export default component.exports